var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18a9.014 9.014 0 01-9-9 9.014 9.014 0 019-9 9.014 9.014 0 019 9 9.014 9.014 0 01-9 9zm-.14-4.76a1.376 1.376 0 00-.97.36 1.223 1.223 0 00-.38.92 1.245 1.245 0 00.37.91 1.372 1.372 0 00.98.36 1.316 1.316 0 00.98-.36 1.207 1.207 0 00.37-.91 1.223 1.223 0 00-.38-.92 1.376 1.376 0 00-.97-.36zm.17-7.89c.86 0 1.3.47 1.3 1.41a1.759 1.759 0 01-.25.89 4.979 4.979 0 01-1.01 1.09 3.955 3.955 0 00-1.04 1.36 4.923 4.923 0 00-.28 1.86h2.14l.03-.51a2.319 2.319 0 01.72-1.43l.68-.64a5.575 5.575 0 001.11-1.4 2.971 2.971 0 00.32-1.34 3.073 3.073 0 00-.98-2.42 4.063 4.063 0 00-2.74-.86 4.09 4.09 0 00-2.77.9 3.215 3.215 0 00-1.03 2.49h2.42a1.506 1.506 0 01.39-1.05 1.357 1.357 0 01.99-.35z"
  })));
};

export default SvgSupport;